import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface UpgradeVersionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function UpgradeVersionsDialog({ open, onOpenChange }: UpgradeVersionsDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center mb-2">
            <Sparkles className="w-5 h-5 text-foreground" />
          </div>
          <DialogTitle>Versioning is a paid feature</DialogTitle>
          <DialogDescription className="pt-1">
            Upgrade to a paid plan to create new versions and keep a complete
            history of every iteration. You'll still be able to view your
            existing version on the Free plan.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Maybe later
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate("/plans");
            }}
            className="bg-foreground text-background hover:bg-accent hover:text-foreground"
          >
            View plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
